var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFavorite = function SvgFavorite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#fff",
    viewBox: "0 0 256 256"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M183.8 14.2c-21.6 0-42.3 10-55.8 25.9-13.5-15.9-34.2-25.9-55.8-25.9C34 14.2 4 44.2 4 82.4c0 46.9 42.2 85.1 106 143.1l18 16.2 18-16.4c63.9-57.9 106-96.1 106-143 0-38.1-30-68.1-68.2-68.1m-54.6 192.9-1.2 1.2-1.2-1.2c-59-53.4-98-88.8-98-124.6C28.8 57.6 47.4 39 72.2 39c19.1 0 37.7 12.3 44.3 29.3h23.2c6.4-17 25-29.3 44.1-29.3 24.8 0 43.4 18.6 43.4 43.4 0 35.9-38.9 71.2-98 124.7"
  })));
};
export default SvgFavorite;